export { SwitchHorizontal as default } from './SwitchHorizontal';
